import React from 'react'
import MaterialSymbol from '../material-symbol'

const Edit = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="edit" {...props} />
))

Edit.displayName = 'Edit'

export default Edit
